// extracted by mini-css-extract-plugin
module.exports = {"wrap":"pl-z","heading":"ql-z","items":"rl-z","featureCss":"sl-z","disabled":"tl-z","imgCss":"ul-z"};